import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: null,
    name: '',           //塾名
    code: '',           //取引先コード(お客様No.)
    tel: '',            //電話番号
    email: '',          //メールアドレス
    postCode: '',       //郵便番号
    address: '',        //住所
    representative: '', //EN担当者氏名
    billing: '',        //請求方法
    logoUrl: '',        //ロゴ画像URL
    logoFilename: '',        //ロゴ画像ファイル名
    logo: new File([], '', { }),         //ロゴファイル
    logoImage: '',         //ロゴプレビューファイル
    customerValid: true,  // 塾情報に入力不備がないか
  },

  getters: {
    title: state => {
      return state.id ? '編集' : '新規作成'
    },
    url: state => {
      return state.id
        ? `api/v1/admin/customers/${state.id}`
        : 'api/v1/admin/customers'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    data: state => {
      let form = new FormData()
      form.append('customer[name]', state.name)
      form.append('customer[postCode]]', state.postCode)
      form.append('customer[code]', state.code)
      form.append('customer[tel]', state.tel)
      form.append('customer[email]', state.email)
      form.append('customer[address]', state.address)
      form.append('customer[representative]', state.representative)
      form.append('customer[billing]', state.billing)
      if(state.logo) form.append('customer[logo]', state.logo)
      return form
    },
  },

  mutations: {
    setLogo(state, payload) {
      state.logo = payload.logo;
    },
    setLogoImage(state, payload) {
      state.logoImage = payload.logoImage;
    },
    setCustomerValid(state, payload) {
      state.customerValid = payload.valid
    },
    setSchool(state, payload) {
      Object.assign(state, payload)
    },
    initialize(state) {
      state.id             = null
      state.code           = ''
      state.name           = ''
      state.postCode       = ''
      state.address        = ''
      state.tel            = ''
      state.email          = ''
      state.representative = ''
      state.billing        = ''
      state.logo           = null
      state.logoImage      = null
      state.logoUrl        = '';
      state.logoFilename   = '';
      state.customerValid  = true
    },
  },

  actions: {
    async submit({ getters }) {
      const customer = getters.data
      const url      = getters.url
      const method   = getters.method
      const title    = getters.title

      await axios({
        url: url,
        method: method,
        data: customer
        ,
      })
      return {message: `${title}が完了しました` }
    },
    async getAttached({ state, commit }, payload) {
      if(!payload.filePath || payload.filePath.length === 0) return
      const res = await axios.get(`/api/v1/admin/customers/${state.id}/download`, { responseType: 'blob', dataType: 'binary' })
      const blob = new Blob([res.data], { type: res.data.type })
      const file = new File([blob], payload.filename, { type: res.data.type })
      commit('setLogo', {
        logo: file,
      })
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        commit('setLogoImage', { logoImage:  e.target.result})
      }
    },
  },
}
